import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import Chip from "@mui/material/Chip";
import { ActionContext } from "context/ActionContext";
import UserService from "services/UserService";
import {
  putAction,
  getAction,
  getProfilePicture,
  postFileUpload,
  getFiles,
} from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { AutocompleteInput, TextInput } from "components/Input/Index.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import EditButton from "components/CustomButtons/EditButton";
import { action as actionVar } from "variables/action";

export default function CommentsEdit({ apiData, params, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;

  const [newComments, setNewComments] = useState({});
  const [imageUrl, setImageUrl] = useState(null);
  const [imageCode, setImageCode] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);

  const [associatedfiles, setAssociatedfiles] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewComments((prevState) => ({
      ...prevState,
      [params]: { ...prevState.comments, [name]: value },
    }));
  };

  const handleAssociatedfilesChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setAssociatedfiles(newArray);
  };

  useEffect(() => {
    setNewComments(action?.parameters || {});
    let imageCode = action?.parameters?.comments?.imageCode;
    if (imageCode) {
      setImageCode(imageCode);
      setImagePreviewUrl(getProfilePicture(imageCode));
    }
  }, [action]);

  //Send picture
  useEffect(() => {
    console.log("Image url change", imageUrl);
    if (imageUrl) {
      const formData = new FormData();
      // we append each element to the form
      formData.append("files", imageUrl);
      axios
        .post(postFileUpload(0, "profilepic"), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          //console.log(res.data);
          //console.log(res.data.files[0].url);
          setImageCode(res.data.files[0].url);
          setImagePreviewUrl(getProfilePicture(res.data.files[0].url));
        })
        .catch(() => {});
    }
  }, [imageUrl]);

  //Get Ged
  useEffect(() => {
    axios
      .get(getFiles(action?.parameters?.["general"]?.groups[0]), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const urlPlanAction = getAction(action.id);

  let url = putAction(action.id);

  const handleSubmit = (event) => {
    createActionComments(event);
  };

  const createActionComments = async (event) => {
    axios
      .put(
        url,
        { ...newComments, comments: { ...newComments.comments, imageCode } },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setAction((prevState) => ({
            ...prevState,
            parameters: {
              ...newComments,
              comments: { ...newComments.comments, imageCode },
            },
          }));
          setNotification("success", "Commentaires modifée");
          getActionData();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const getActionData = () => {
    axios
      .get(urlPlanAction, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        setAction(response.data || []);
        setNewComments(response.data.parameters || {});
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
          <ImageUpload
            file={imageUrl}
            setImageCode={setImageCode}
            setFile={setImageUrl}
            imagePreviewUrl={imagePreviewUrl}
            setImagePreviewUrl={setImagePreviewUrl}
            disabled={!actionplanupdate}
          />
          <AutocompleteInput
            inputTitle={"Fichiers associés"}
            selected={selectedGed()}
            list={gedList}
            handleChange={(_, newValue) =>
              handleAssociatedfilesChange(newValue)
            }
            renderTags={(tagValue, getTagProps) =>
              tagValue.map((option, index) => (
                <Chip label={option.title} {...getTagProps({ index })} />
              ))
            }
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params]["comments"]}
            textInput={newComments?.[params]?.["comments"] || ""}
            handleTextInputChange={handleChange}
            name="comments"
            multiline
            rows={4}
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      {actionplanupdate && (
        <GridContainer>
          <GridItem
            xs={12}
            sm={12}
            md={7}
            lg={7}
            style={{ marginLeft: "8px", marginTop: "12px" }}
          >
            <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
